import { observer } from "mobx-react";
import { AppBar, IconButton, Toolbar, Typography, Box } from "@mui/material";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import MobileDrawer from "./MobileDrawer";
import { useState } from "react";

const Header = observer(() => {
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const mobileMenu = showMenu && (
    <MobileDrawer open={true} onClose={() => setShowMenu(false)} />
  );
  return (
    <>
      <AppBar
        sx={{
          display: "flex",
          backgroundColor: "#00bcd4",
          zIndex: 10,
        }}
      >
        <Toolbar>
          <Box />
          <Typography
            sx={{
              color: "white",
              fontSize: 25,
              flexGrow: 1,
              textAlign: "center",
              fontWeight: "bold",
            }}
          >
            Hälsodagbok
          </Typography>
          <IconButton
            sx={{ display: { md: "none" } }}
            color="inherit"
            aria-label="open menu"
            edge="end"
            onClick={() => setShowMenu(true)}
          >
            <MenuOutlinedIcon />
          </IconButton>
        </Toolbar>
        {mobileMenu}
      </AppBar>
    </>
  );
});

export default Header;
